import { BUTTON_CELL_SCHEVRON_DISPLAY_NAME } from "./core";
import createTestId from "../../../../fabrics/createTestId";

export const createTestIdForButtonCellSchevronElement = createTestId(
    BUTTON_CELL_SCHEVRON_DISPLAY_NAME,
);
